import { useBaseCrudService } from 'framework/crud';
import { useRecruitmentApi } from 'infrastructure/api';
import resumeValidation from 'domain/recruiting/candidate/Timeline/resume/form/resumeValidation';
import { FormFieldsData } from 'framework/form';
import { useMessageService, ErrorMessage } from 'framework/ui/Message';
import { useParams } from 'react-router-dom';

export const READ_CANDIDATE_RESUMES = 'READ_CANDIDATE_RESUMES';

export const CREATE_CANDIDATE_RESUME = 'CREATE_CANDIDATE_RESUME';

export const DISPLAY_RESUME_DELETE_BUTTON_PERMISSION = 'FE_DELETE_CANDIDATE_RESUME';

export const DISPLAY_RESUME_UPDATE_BUTTON_PERMISSION = 'FE_UPDATE_CANDIDATE_RESUME';

export enum ResumeType {
  STAND_ALONE = 'STAND_ALONE',
  APPLICATION_RESUME = 'APPLICATION_RESUME',
}

const useResumeService = () => {
  const { addMessage } = useMessageService();
  const { id: candidateId } = useParams<Dictionary<string>>();
  const { deleteById, update: baseUpdate } = useBaseCrudService({
    singleResourceUrl: `/candidates/resumes/:id`,
    listResourceUrl: `/candidates/resumes`,
    useService: useRecruitmentApi,
  });
  const { sendPostRequest } = useRecruitmentApi();

  const parseCandidateDataFromResume = async (uuid: string) => {
    const response = await sendPostRequest(`/candidates/resumes/parse/${uuid}`);
    const result = await response.json();
    return result.info || result;
  };

  const getValidationSchema = () => Promise.resolve(resumeValidation);

  const update = async (resumeId: StringOrNumber, formData: FormFieldsData) => {
    try {
      const processedData = { ...formData };

      if (!processedData.candidateId && candidateId) {
        processedData.candidateId = candidateId;
      }

      if (processedData.artifacts && Array.isArray(processedData.artifacts) && !processedData.resumeArtifactIds) {
        processedData.resumeArtifactIds = processedData.artifacts;
      }

      return await baseUpdate(resumeId, processedData);
    } catch (error) {
      addMessage(new ErrorMessage('Error during updating resume'));
      throw error;
    }
  };

  return {
    deleteById,
    update,
    getValidationSchema,
    parseCandidateDataFromResume,
  };
};

export default useResumeService;
